import { useEffect, useState } from "react";
import Content from "@/components/Content";
import SearchJobs from "@/components/SearchJobs";
import { groupData } from "./Utils";
import ProgramList from "./ProgramList";
import { CompanyPrograms } from "./CompanyProgramModel";
import { GetCompanyProgramList } from "@/services/CompanyService";

export default function Dashboard() {
  
    const data = GetCompanyProgramList();
  
    const [dataList, setDataList] = useState<Record<string, CompanyPrograms[]>>(
      {}
    );
  
    useEffect(() => {
      setDataList(groupData(data));
    }, [data]);
    return (
      <Content>
        <div className="pt-20 md:pt-32 lg:pt-24 sm:px-8">
          <SearchJobs />
        </div>
        <div>
          <ProgramList dataList={dataList} />
        </div>
      </Content>
    );
  }